import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React, { useContext } from 'react';
import { FormInputChoice } from '@tesla/design-system-react';
import { RadioGroupContext } from './context.js';

var _excluded = ["value", "label", "caption"];

/**
 * Renders a radio button
 *
 * @param {Object} props
 * @param {*} props.value
 * @param {String} props.label
 * @param {String} props.caption
 */
function Radio(_ref) {
  var value = _ref.value,
    label = _ref.label,
    caption = _ref.caption,
    userProps = _objectWithoutProperties(_ref, _excluded);
  var context = useContext(RadioGroupContext);
  if (typeof context === 'undefined') {
    throw new Error('<Radio> should be rendered inside of a <RadioGroup> component');
  }
  var radioGroupApi = context.radioGroupApi,
    radioGroupState = context.radioGroupState,
    name = context.name;
  var setValue = radioGroupApi.setValue,
    setTouched = radioGroupApi.setTouched;
  var groupValue = radioGroupState.value;
  var id = "".concat(context.id, "_").concat(value);
  return /*#__PURE__*/React.createElement(FormInputChoice, _extends({
    type: "radio",
    labelProps: {
      caption: caption
    },
    label: label,
    id: id,
    value: value,
    name: name,
    checked: groupValue === value,
    onChange: function onChange(e) {
      if (!e.target.checked) {
        return;
      }
      setValue(value);
    },
    onBlur: function onBlur() {
      setTouched(true);
    }
  }, userProps));
}

export { Radio };
